import React, { FC } from "react";
import "./VideoSourceDropdown.scss";

type AudioSourceDropdownProps = {
  audioDevices: MediaDeviceInfo[];
  selectedAudioDevice: string | null;
  onSelect: (deviceId: string) => void;
};

const AudioSourceDropdown: FC<AudioSourceDropdownProps> = ({
  audioDevices,
  selectedAudioDevice,
  onSelect,
}) => {
  return (
    <div className="settings-row">
      <label className="control-label">Audio Source:</label>
      <div className="settings-row-controls">
        <select
          className="btn btn-light btn-extra-small media-source-select"
          value={selectedAudioDevice ?? ""}
          onChange={(e) => onSelect(e.target.value)}
        >
          {audioDevices.map((device, index) => (
            <option key={device.deviceId} value={device.deviceId}>
              {device.label || `Audio Source ${index + 1}`}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default AudioSourceDropdown;
